{
  "MACROS": {
    "HEADER": "Makrokomandos",
    "DESCRIPTION": "A macro is a set of saved actions that help customer service agents easily complete tasks. The agents can define a set of actions like tagging a conversation with a label, sending an email transcript, updating a custom attribute, etc., and they can run these actions in a single click.",
    "LEARN_MORE": "Learn more about macros",
    "HEADER_BTN_TXT": "Pridėti naują makrokomandą",
    "HEADER_BTN_TXT_SAVE": "Išsaugoti makrokomandą",
    "LOADING": "Gaunama makrokomanda",
    "ERROR": "Kažkas nepavyko. Bandykite dar kartą",
    "ORDER_INFO": "Makrokomandos bus paleistos ta tvarka, kuria pridėsite veiksmus. Galite juos pertvarkyti vilkdami už rankenos šalia kiekvieno mazgo.",
    "ADD": {
      "FORM": {
        "NAME": {
          "LABEL": "Makrokomandos pavadinimas",
          "PLACEHOLDER": "Įveskite makrokomandos pavadinimą",
          "ERROR": "Kuriant makrokomandą būtinas pavadinimas"
        },
        "ACTIONS": {
          "LABEL": "Veiksmai"
        }
      },
      "API": {
        "SUCCESS_MESSAGE": "Makrokomanda sėkmingai pridėta",
        "ERROR_MESSAGE": "Nepavyko sukurti makrokomandos, bandykite dar kartą vėliau"
      }
    },
    "LIST": {
      "TABLE_HEADER": {
        "NAME": "Vardas",
        "CREATED BY": "Sukurtas",
        "LAST_UPDATED_BY": "Paskutinį kartą atnaujino",
        "VISIBILITY": "Matomumas"
      },
      "404": "Nerasta makrokomandų"
    },
    "DELETE": {
      "TOOLTIP": "Ištrinti makrokomandą",
      "CONFIRM": {
        "MESSAGE": "Ar tikrai norite ištrinti ",
        "YES": "Taip, Ištrinti",
        "NO": "Ne"
      },
      "API": {
        "SUCCESS_MESSAGE": "Makrokomanda sėkmingai ištrinta",
        "ERROR_MESSAGE": "Ištrinant makrokomandą įvyko klaida. Pabandykite dar kartą vėliau"
      }
    },
    "EDIT": {
      "TOOLTIP": "Redaguoti makrokomandą",
      "API": {
        "SUCCESS_MESSAGE": "Makrokomanda sėkmingai atnaujinta",
        "ERROR_MESSAGE": "Nepavyko atnaujinti makrokomandos. Pabandykite dar kartą vėliau"
      }
    },
    "EDITOR": {
      "START_FLOW": "Pradėti srautą",
      "END_FLOW": "Baigti srautą",
      "LOADING": "Gaunama makrokomanda",
      "ADD_BTN_TOOLTIP": "Pridėti naują veiksmą",
      "DELETE_BTN_TOOLTIP": "Ištrinti Veiksmą",
      "VISIBILITY": {
        "LABEL": "Makrokomandos matomumas",
        "GLOBAL": {
          "LABEL": "Viešas",
          "DESCRIPTION": "Ši makrokomanda yra viešai prieinama visiems šios paskyros agentams."
        },
        "PERSONAL": {
          "LABEL": "Privatus",
          "DESCRIPTION": "Ši makrokomanda bus prieinama tik jums ir nepasiekiama kitiems."
        }
      }
    },
    "EXECUTE": {
      "BUTTON_TOOLTIP": "Vykdyti",
      "PREVIEW": "Peržiūrėti makrokomandą",
      "EXECUTED_SUCCESSFULLY": "Sėkmingai įvykdyta makrokomanda"
    },
    "ERRORS": {
      "ATTRIBUTE_KEY_REQUIRED": "Attribute key is required",
      "FILTER_OPERATOR_REQUIRED": "Filter operator is required",
      "VALUE_REQUIRED": "Reikalinga vertė",
      "VALUE_MUST_BE_BETWEEN_1_AND_998": "Value must be between 1 and 998",
      "ACTION_PARAMETERS_REQUIRED": "Action parameters are required",
      "ATLEAST_ONE_CONDITION_REQUIRED": "At least one condition is required",
      "ATLEAST_ONE_ACTION_REQUIRED": "At least one action is required"
    },
    "ACTIONS": {
      "ASSIGN_TEAM": "Priskirti komandai",
      "ASSIGN_AGENT": "Priskirti agentui",
      "ADD_LABEL": "Pridėti etiketę",
      "REMOVE_LABEL": "Pašalinti etiketę",
      "REMOVE_ASSIGNED_TEAM": "Pašalinti priskirtą komandą",
      "SEND_EMAIL_TRANSCRIPT": "Siųsti pokalbio įrašą el. paštu",
      "MUTE_CONVERSATION": "Nutildyti pokalbį",
      "SNOOZE_CONVERSATION": "Atidėti pokalbį",
      "RESOLVE_CONVERSATION": "Išspręsti pokalbį",
      "SEND_ATTACHMENT": "Siųsti priedą",
      "SEND_MESSAGE": "Siųsti pranešimą",
      "CHANGE_PRIORITY": "Keisti prioritetą",
      "ADD_PRIVATE_NOTE": "Pridėti privačią pastabą",
      "SEND_WEBHOOK_EVENT": "Siųsti webhook įvykį"
    },
    "ACTION_VALUES": {
      "SELF": "Aš"
    }
  }
}
